import { render, staticRenderFns } from "./AllPersonInRegister.vue?vue&type=template&id=c57c7cc0&scoped=true&"
import script from "./AllPersonInRegister.vue?vue&type=script&lang=js&"
export * from "./AllPersonInRegister.vue?vue&type=script&lang=js&"
import style0 from "./AllPersonInRegister.vue?vue&type=style&index=0&id=c57c7cc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57c7cc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VChip,VDataTable,VSelect,VSpacer,VTextField,VToolbar,VToolbarTitle})
